import React from 'react';

const Form = props => (
    <form className="city-country-form" onSubmit={props.getWeather}>
        <input type="text" name="city" placeholder="City"/>
        <input type="text" name="country" placeholder="Country"/>
        <button className="ripple">Get Weather</button>
    </form>
);

export default Form;